import Toast from '../constants/constants';
import ApiCalls from '../classes/ApiCalls';
import store from '../state/store/Store';

export class AttendanceRepository
{
    create()
    {
        backdrop.show('Filtering Attendance...Please wait!');
        let form = $('#filter-attendance-form');
        let formData = form.serialize();

        let success = function(response){
            backdrop.hide();
            Toast.fire({
                icon: response.type,
                title: response.title
            });
            if (response.type === 'success'){
                window.location.reload()
            }
        }
        let datePeriod = form.find('#attendance-date-period');
        let dateArray = datePeriod.val().split(' to ');

        let dateFrom = form.find('#attendance-filter-date-from');
        let dateTo = form.find('#attendance-filter-date-to');

        dateFrom.val(dateArray[0]);
        dateTo.val(dateArray[1]);

        let errorMessage = 'Failed to filter attendance. Please check your connection and try again or contact your System Administrator';

        form.submit();

        // new ApiCalls(formData, form.attr('action'), success, errorMessage, '', 'get').dispatch()
    }
}
